<template>
  <div class="geo-heatmap" ref="chartContainer"></div>
</template>

<script>
import * as echarts from 'echarts/core'
import { MapChart, EffectScatterChart } from 'echarts/charts'
import { TooltipComponent, VisualMapComponent, GeoComponent } from 'echarts/components'
import { CanvasRenderer } from 'echarts/renderers'
import { geoData } from '../mock/data'

echarts.use([MapChart, EffectScatterChart, TooltipComponent, VisualMapComponent, GeoComponent, CanvasRenderer])

export default {
  name: 'GeoHeatMap',
  data() {
    return { chart: null }
  },
  mounted() {
    this.loadMap()
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    if (this.chart) this.chart.dispose()
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    loadMap() {
      var self = this
      fetch('https://geo.datav.aliyun.com/areas_v3/bound/100000_full.json')
        .then(function(res) { return res.json() })
        .then(function(data) {
          echarts.registerMap('china', data)
          self.initChart()
        })
        .catch(function() {
          self.initSimpleChart()
        })
    },
    initChart() {
      this.chart = echarts.init(this.$refs.chartContainer)
      var option = {
        tooltip: {
          trigger: 'item',
          backgroundColor: 'rgba(6,30,60,0.9)',
          borderColor: 'rgba(0,212,255,0.3)',
          textStyle: { color: '#FFFFFF', fontSize: 12 },
          formatter: function(p) {
            if (p.value) {
              return p.name + '<br/>销售额: ' + (p.value / 10000).toFixed(1) + '万元'
            }
            return p.name
          }
        },
        visualMap: {
          min: 50000,
          max: 2200000,
          left: 10,
          bottom: 10,
          text: ['高', '低'],
          textStyle: { color: '#B0D4F1', fontSize: 10 },
          inRange: {
            color: ['#0A1628', '#0D3B66', '#0066AA', '#00A8E8', '#00D4FF']
          },
          calculable: true,
          itemWidth: 12,
          itemHeight: 80
        },
        series: [{
          type: 'map',
          map: 'china',
          roam: false,
          zoom: 1.2,
          center: [104, 36],
          label: {
            show: false
          },
          emphasis: {
            label: { show: true, color: '#FFFFFF', fontSize: 12 },
            itemStyle: { areaColor: '#00D4FF', shadowBlur: 10, shadowColor: 'rgba(0,212,255,0.5)' }
          },
          itemStyle: {
            areaColor: '#0D2137',
            borderColor: 'rgba(0,212,255,0.3)',
            borderWidth: 1
          },
          data: geoData
        }]
      }
      this.chart.setOption(option)
    },
    initSimpleChart() {
      this.chart = echarts.init(this.$refs.chartContainer)
      var option = {
        title: {
          text: '地图加载中...',
          left: 'center',
          top: 'center',
          textStyle: { color: '#B0D4F1', fontSize: 14 }
        }
      }
      this.chart.setOption(option)
    },
    handleResize() {
      if (this.chart) this.chart.resize()
    }
  }
}
</script>

<style scoped>
.geo-heatmap {
  width: 100%;
  min-height: 200px;
}
</style>
